<div class="header">
  <div class="title">New Time Series Chart</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="addTimeSeriesChartForm">
  <mat-form-field class="flex-auto gt-xs:pr-3">
    <mat-label>What do you want to call this chart?</mat-label>
    <input matInput [formControlName]="'title'" />
  </mat-form-field>

  <div class="actions justify-end">
    <div class="buttons">
      <button class="discard-button" mat-button (click)="discard()" type="button">
        <span>Cancel</span>
      </button>
      <button
        class="send-button"
        mat-flat-button
        type="submit"
        [color]="'primary'"
        [disabled]="addTimeSeriesChartForm.pristine || addTimeSeriesChartForm.invalid"
        (click)="save()"
      >
        <span>Save</span>
      </button>
    </div>
  </div>
</form>
